<template>
    <vs-popup :active.sync="showConfirmationPopup" :buttons-hidden="true">
        <div class="prompt-title mb-2">
            Bid Confirmation
        </div>
        <div class="prompt-body mb-10">
            You are currently targeting websites that will cost more than ${{ maxBidOfSelectedAdset }}. You need to edit or confirm your choices before moving forward. Please ensure that the amount you select equals or is less than your current balance.
        </div>

        <div class="prompt-table">
            <bidding-table
                :domains="domains"
            />
        </div>

        <div class="flex flex-wrap mt-10 md:justify-end btns">

            <!-- Confirm Button -->
            <vs-button
              @click="$emit('confirm')"
              class="w-full ok-btn mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last">
                Confirm
            </vs-button>

            <!-- No Button -->
            <vs-button
                class="w-full cancel-btn md:cancel-btn"
                type="border"
                text-color="#2C2C2C"
                color="#D9D9D9"
                @click="hide()">
                Cancel
            </vs-button>

        </div>
    </vs-popup>
</template>

<script>

import BiddingTable from './bidding-table.vue'

export default {

  name: 'speakol-bidding-confirmation-popup',


  data () {
    return {
      showConfirmationPopup: false,
      domains: []
    }
  },

  components: {
    BiddingTable
  },

  props: {

    maxBidOfSelectedAdset: {
      type: Number,
      default: 0
    }

  },
  methods: {
    hide () {
      const id = this.domains[0].id
      this.$root.$emit(`toggle-${id}`)
      this.showConfirmationPopup = false
    },
    show () {
      this.showConfirmationPopup = true
    },
    setDomains (domains) {
      this.domains = domains
    }
  }
}
</script>

<style scoped lang="scss">
  .btns button {
    border-radius: 3px;
    height: 40px;

    .cancel-btn {
      background: #fff;
    }

    .ok-btn {
      background: #0092d7;
    }
  }

  .prompt-title {
    font-style: normal;
    font-weight: 500;
    font-size: 21px;
    line-height: 40px;
    color: #2c2c2c;
  }

  .prompt-body {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #999;
  }

  /deep/.vs-popup {
    width: 893px;
    height: 456px;
  }

  @media (min-width: 768px) {
    .md\:cancel-btn {
      min-width: 112px !important;
      max-width: 140px;
    }
  }

</style>